export class DOAbnormalTableHeaderUpdateBean {
  moNo: string;
  waitingReference: string | null;

  constructor() {
    this.moNo = "";
    this.waitingReference = null;
  }
}
